<template>
    <ac-modal :title="'Existing Fee Selection'" ref="modal" :size-class="'modal-lg'">
        <fee-selection @onFeeSelected="feeSelected" :consultant-id="consultantId" ref="feeSelection">

        </fee-selection>
    </ac-modal>
</template>

<script>
    import FeeSelection from "./FeeSelection.vue";

    export default {
        name: "FeeSelectionModal",
        components: {FeeSelection},
        props: {consultantId: {type: [Number], required: true}},
        data() {
            return {
                widgetReady: false
            };
        },
        async mounted() {
            let self = this;
            $(this.$refs.modal.$refs.modal).off('shown.bs.modal').on('shown.bs.modal', () => {
                self.$nextTick().then(() => {
                    self.$refs.feeSelection.init();
                });
            });
        },
        methods: {
            feeSelected(fee) {
                this.$emit('onFeeSelected', fee);
                this.$refs.modal.close();
            },
            async showModal() {
                this.$refs.modal.open();
            },
        }
    }
</script>

<style scoped>

</style>